module.exports = __webpack_public_path__ + "img/desktop.4a1bdcd8.png";